// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { convertDDtoDMSPref } from 'helpers/coordsConversion'
import { precisionKm } from 'config/constants'

import {
  castToString,
  ifObjectGetValue,
  roundAndLeaveTrailingZeroes,
} from 'helpers/reduxFormFunctions'

// instead of creating custom formatters for these cells,
// just put the values of interest at the top level of the object.
const prepData = arr => (
  arr.map(d => {
    d.asr = castToString(d.asr)
    d.callSign = castToString(d.callSign)
    d.contactCode = ifObjectGetValue(d.contact, 'contactCode')
    // if no coords were defined, this will be null
    // the hyphen is a decorative UI piece
    d.distance = roundAndLeaveTrailingZeroes(d.distance, precisionKm) || '-'
    d.latitude = convertDDtoDMSPref(d.latitude, 'latitude')
    d.longitude = convertDDtoDMSPref(d.longitude, 'longitude')
    d.uniqueId = 'siteId' // so that DataTable can create a unique id
    return d
  })
)

export default prepData
